// source: manifest.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var entity_pb = require('./entity_pb.js');
goog.object.extend(proto, entity_pb);
var job_pb = require('./job_pb.js');
goog.object.extend(proto, job_pb);
goog.exportSymbol('proto.cloud.Manifest', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.cloud.Manifest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.cloud.Manifest.repeatedFields_, null);
};
goog.inherits(proto.cloud.Manifest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.cloud.Manifest.displayName = 'proto.cloud.Manifest';
}

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.cloud.Manifest.repeatedFields_ = [7,22,32];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.cloud.Manifest.prototype.toObject = function(opt_includeInstance) {
  return proto.cloud.Manifest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.cloud.Manifest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.cloud.Manifest.toObject = function(includeInstance, msg) {
  var f, obj = {
    manifestId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    manifestName: jspb.Message.getFieldWithDefault(msg, 2, ""),
    manifestDescription: jspb.Message.getFieldWithDefault(msg, 3, ""),
    dateCreated: jspb.Message.getFieldWithDefault(msg, 4, ""),
    dateUpdated: jspb.Message.getFieldWithDefault(msg, 5, ""),
    userCreatedBy: jspb.Message.getFieldWithDefault(msg, 6, ""),
    usersTaggedList: (f = jspb.Message.getRepeatedField(msg, 7)) == null ? undefined : f,
    jobsList: jspb.Message.toObjectList(msg.getJobsList(),
    job_pb.JobInfoQuery.toObject, includeInstance),
    entitiesList: jspb.Message.toObjectList(msg.getEntitiesList(),
    entity_pb.Entity.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.cloud.Manifest}
 */
proto.cloud.Manifest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.cloud.Manifest;
  return proto.cloud.Manifest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.cloud.Manifest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.cloud.Manifest}
 */
proto.cloud.Manifest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setManifestId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setManifestName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setManifestDescription(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setDateCreated(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setDateUpdated(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserCreatedBy(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.addUsersTagged(value);
      break;
    case 22:
      var value = new job_pb.JobInfoQuery;
      reader.readMessage(value,job_pb.JobInfoQuery.deserializeBinaryFromReader);
      msg.addJobs(value);
      break;
    case 32:
      var value = new entity_pb.Entity;
      reader.readMessage(value,entity_pb.Entity.deserializeBinaryFromReader);
      msg.addEntities(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.cloud.Manifest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.cloud.Manifest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.cloud.Manifest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.cloud.Manifest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getManifestId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getManifestName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getManifestDescription();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getDateCreated();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getDateUpdated();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getUserCreatedBy();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getUsersTaggedList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      7,
      f
    );
  }
  f = message.getJobsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      22,
      f,
      job_pb.JobInfoQuery.serializeBinaryToWriter
    );
  }
  f = message.getEntitiesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      32,
      f,
      entity_pb.Entity.serializeBinaryToWriter
    );
  }
};


/**
 * optional string manifest_id = 1;
 * @return {string}
 */
proto.cloud.Manifest.prototype.getManifestId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.cloud.Manifest} returns this
 */
proto.cloud.Manifest.prototype.setManifestId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string manifest_name = 2;
 * @return {string}
 */
proto.cloud.Manifest.prototype.getManifestName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.cloud.Manifest} returns this
 */
proto.cloud.Manifest.prototype.setManifestName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string manifest_description = 3;
 * @return {string}
 */
proto.cloud.Manifest.prototype.getManifestDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.cloud.Manifest} returns this
 */
proto.cloud.Manifest.prototype.setManifestDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string date_created = 4;
 * @return {string}
 */
proto.cloud.Manifest.prototype.getDateCreated = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.cloud.Manifest} returns this
 */
proto.cloud.Manifest.prototype.setDateCreated = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string date_updated = 5;
 * @return {string}
 */
proto.cloud.Manifest.prototype.getDateUpdated = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.cloud.Manifest} returns this
 */
proto.cloud.Manifest.prototype.setDateUpdated = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string user_created_by = 6;
 * @return {string}
 */
proto.cloud.Manifest.prototype.getUserCreatedBy = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.cloud.Manifest} returns this
 */
proto.cloud.Manifest.prototype.setUserCreatedBy = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * repeated string users_tagged = 7;
 * @return {!Array<string>}
 */
proto.cloud.Manifest.prototype.getUsersTaggedList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 7));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.cloud.Manifest} returns this
 */
proto.cloud.Manifest.prototype.setUsersTaggedList = function(value) {
  return jspb.Message.setField(this, 7, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.cloud.Manifest} returns this
 */
proto.cloud.Manifest.prototype.addUsersTagged = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 7, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.cloud.Manifest} returns this
 */
proto.cloud.Manifest.prototype.clearUsersTaggedList = function() {
  return this.setUsersTaggedList([]);
};


/**
 * repeated JobInfoQuery jobs = 22;
 * @return {!Array<!proto.cloud.JobInfoQuery>}
 */
proto.cloud.Manifest.prototype.getJobsList = function() {
  return /** @type{!Array<!proto.cloud.JobInfoQuery>} */ (
    jspb.Message.getRepeatedWrapperField(this, job_pb.JobInfoQuery, 22));
};


/**
 * @param {!Array<!proto.cloud.JobInfoQuery>} value
 * @return {!proto.cloud.Manifest} returns this
*/
proto.cloud.Manifest.prototype.setJobsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 22, value);
};


/**
 * @param {!proto.cloud.JobInfoQuery=} opt_value
 * @param {number=} opt_index
 * @return {!proto.cloud.JobInfoQuery}
 */
proto.cloud.Manifest.prototype.addJobs = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 22, opt_value, proto.cloud.JobInfoQuery, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.cloud.Manifest} returns this
 */
proto.cloud.Manifest.prototype.clearJobsList = function() {
  return this.setJobsList([]);
};


/**
 * repeated Entity entities = 32;
 * @return {!Array<!proto.cloud.Entity>}
 */
proto.cloud.Manifest.prototype.getEntitiesList = function() {
  return /** @type{!Array<!proto.cloud.Entity>} */ (
    jspb.Message.getRepeatedWrapperField(this, entity_pb.Entity, 32));
};


/**
 * @param {!Array<!proto.cloud.Entity>} value
 * @return {!proto.cloud.Manifest} returns this
*/
proto.cloud.Manifest.prototype.setEntitiesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 32, value);
};


/**
 * @param {!proto.cloud.Entity=} opt_value
 * @param {number=} opt_index
 * @return {!proto.cloud.Entity}
 */
proto.cloud.Manifest.prototype.addEntities = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 32, opt_value, proto.cloud.Entity, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.cloud.Manifest} returns this
 */
proto.cloud.Manifest.prototype.clearEntitiesList = function() {
  return this.setEntitiesList([]);
};


goog.object.extend(exports, proto.cloud);
